// extracted by mini-css-extract-plugin
module.exports = {"root":"TableContainer_root__ahExi"};